import { dealerModeVersion, legacyVersion, newOrderVersion } from './versions';

const { REACT_APP_VERSION_TYPE: VERSION_VALUE } = process.env;

export const VERSION = Object.freeze({
  isLegacy: VERSION_VALUE === legacyVersion,
  isNewOrder: VERSION_VALUE === newOrderVersion,
  isDealerMode: VERSION_VALUE === dealerModeVersion,
});
